
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function withAuth(Component) {
  return function AuthenticatedComponent(props) {
    const navigate = useNavigate();

    useEffect(() => {
      const token = localStorage.getItem('ppcdata');
      if (!token) {
        navigate('/'); 
      }
    }, [navigate]);

    return <Component {...props} />;
  };
}